import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

const AdminLogin = ({ setIsAdmin }) => {
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://node.aattumtpl.com/api/auth/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      });
      const data = await res.json();

      if (data.success) {
        setMessage("✅ Login successful");
        localStorage.setItem("isAdmin", "true");
        localStorage.setItem("adminUser", JSON.stringify(data.user));
        setIsAdmin(true);
        navigate("/dashboard");
      } else {
        setMessage("❌ " + data.message);
      }
    } catch (err) {
      setMessage("⚠️ Server error");
    }
  };

  return (
    <div className="admin-login-container">


      {/* Login Card */}
      <div className="admin-login-card">
        <div className="landing-logo90">
          <img src="/Images/AATTUM-Logo.png" alt="KPL Logo" />
        </div>
        <h1 className="portal-name">Welcome Back! KPL Admin Portal</h1>
        <p className="admin-login-subtitle">Please log in to continue</p>

        <form onSubmit={handleLogin} className="admin-login-form">
          <input
            type="text"
            placeholder="Enter Admin ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            className="admin-login-input"
            required
          />
          <button type="submit" className="admin-login-btn">
            Login
          </button>
        </form>

        {message && <p className="admin-login-message">{message}</p>}
      </div>
    </div>
  );
};

export default AdminLogin;
